/* eslint-disable import/prefer-default-export */
import cx from 'classnames'
import { isEmpty } from 'lodash'
import * as React from 'react'
import { match, NavLink } from 'react-router-dom'
import { getHtmlSelectorValueBy } from '@src/utils/css.selector.helper'
import * as styles from '../../sidebar.layout.styl'
import { ExpandSection } from './expand.section'

export interface MenuSectionProps {
  isDisabled?: boolean
  match: match<{}>
}

export const MenuSection: React.FC<MenuSectionProps> = ({
  children,
  match,
  isDisabled
}: React.PropsWithChildren<MenuSectionProps>) => (
  <div
    className={cx(styles.navigation, {
      [styles.disabled]: isDisabled
    })}
  >
    {React.Children.map<React.ReactElement, React.ReactElement>(
      children as React.ReactElement,
      (item, index) => {
        const { subItems, isCollapsed } = item.props
        const hasSubItems = subItems && subItems?.length > 0
        const Components = hasSubItems
          ? {
              component: ExpandSection,
              props: {
                isCollapsed
              }
            }
          : { component: NavLink }
        const url = !isEmpty(item?.props?.url) ? `/${item.props.url}` : null
        return (
          <div className={styles.navLinkContainer} key={index}>
            <Components.component
              {...Components.props}
              items={subItems}
              to={url}
              key={`item-${item.props.url}`}
              activeClassName={styles.active}
              id={getHtmlSelectorValueBy(`${item.props.title} Nav`)}
            >
              <>{item}</>
            </Components.component>
          </div>
        )
      }
    )}
  </div>
)
